export default {
  en: {
    pageTitle: 'Action Centre',
    addUser: 'Add user',
    errorLoading: 'There was an error loading.',
    info: {
      noRequests: 'No requests found matching the filters.',
    },
    connections: {
      received: '{org} added you as a {role}.',
      messageFrom: 'Message from {org}',
      messageTo: 'Message to {org}',
      rejectionReasonFrom: 'Rejection reason from {org}',
      rejectionReasonTo: 'Rejection reason to {org}',
      addReviewer: 'Is a colleague better suited to review this request?',
      pointOfContact: 'Provided contact',
      noContactProvided: 'No contact provided',
      contactInfo: '{name} ({email})',
      contactEmailDeliveryFailed: "This email couldn't be delivered. Check the address and resend.",
      contactHelpReceived:
        'The contact in your organisation that {org} provided to help verify this request',
      contactHelpSent: 'The contact at {org} you provided to help verify this request',
      sent: '{user} added {org} as a {role}.',
      you: 'You',
      deletedUser: 'Deleted user',
      accept: 'Accept',
      reject: 'Reject',
      cancel: 'Cancel',
      filters: {
        received: 'Received',
        sent: 'Sent',
        all: 'All',
        allStatuses: 'All statuses',
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
      columnOrgName: 'Organisation name',
      columnSupplierName: 'Supplier name',
      columnClientName: 'Client name',
      columnProvidedContact: 'Provided contact',
      columnDateSent: 'Date sent',
      columnSentBy: 'Sent by',
      columnStatus: 'Status',
      searchPlaceholder: 'Search by supplier, contact, or email',
      status: {
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
      actionsMenu: {
        viewSupplier: 'View supplier',
        viewClient: 'View client',
        viewMessage: 'View message',
        cancelRequest: 'Cancel request',
        updateContactAndResend: 'Update contact and resend',
        acceptRequest: 'Accept request',
        rejectRequest: 'Reject request',
        copyInviteLink: 'Copy invite link',
      },
      messageModal: {
        title: 'Message',
        description: 'Connection request for {org}',
        close: 'Close',
      },
      rejectModal: {
        title: 'Reject connection request?',
        description:
          'This will decline the request from {org}. You can include a reason to help them understand the decision.',
        reasonLabel: 'Reason',
        reasonPlaceholder: 'e.g. Wrong organisation, not a current supplier, request sent in error',
        cancel: 'Cancel',
        reject: 'Reject request',
      },
      resendModal: {
        title: 'Connect with {org}',
        description:
          'To help {org} verify your connection request, include the name of your account manager or another identifier such as an account number in the message below.',
        contactNameLabel: 'Contact name',
        contactEmailLabel: 'Contact email address',
        messageLabel: 'Message',
        primerConfirm: 'I confirm a Primer email has been sent to the supplier.',
        primerConfirmError: 'Please confirm the Primer email has been sent.',
        contactNameRequired: 'Enter a contact name',
        contactEmailRequired: 'Enter a contact email address',
        primerConfirmRequired: 'Confirm the Primer email has been sent',
        cancel: 'Cancel',
        send: 'Send request',
      },
      toast: {
        cancelSuccess: 'Connection request cancelled.',
        cancelError: 'Failed to cancel connection request.',
        acceptSuccess: 'Connection request accepted.',
        acceptError: 'Failed to accept connection request.',
        rejectSuccess: 'Connection request rejected.',
        rejectError: 'Failed to reject connection request.',
        resendSuccess: 'Connection request resent.',
        resendError: 'Failed to resend connection request.',
        copyLinkSuccess: 'Connection request link copied to clipboard.',
        connection_request_resend_email_unchanged:
          "You've already sent a request to this email address. Update the email address to send it again.",
      },
      modal: {
        title: 'Cancel connection request to {0}?',
        description: 'This will cancel the pending request. You can resend it later if needed.',
        cancel: 'Cancel request',
        close: 'Keep request',
      },
    },
    mergeRequest: {
      title: 'Another profile for this supplier has been found',
      cta: 'Review duplicate',
      body1:
        'A member on the Risk Ledger network has created a new supplier profile called {orgName} and invited someone on your team to complete an assessment.',
      body2:
        'If you would like to merge this profile into your existing {orgName} profile, review and claim this duplicate. You will then be able to accept the assessment request.',
      pendingRequests: '1 pending connection request | {n} pending connection requests',
      modal: {
        body1: "We've found another profile that may be a duplicate of {orgName}.",
        body2:
          'Merging will remove the other profile and transfer any pending connection requests to your main supplier profile. This will ensure the accuracy of your profile and avoid confusion for your clients connecting to you.',
        claimCta: 'Merge profiles',
        reject: 'Not a duplicate',
        claimSuccessMessage: 'Successfully claimed duplicate profile',
      },
    },
    remediations: {
      received: '{targetOrg} requested you to remediate control {control}.',
      receivedProduct:
        '{targetOrg} requested you to remediate control {control} in relation to {productName}.',
      sent: 'You requested {targetOrg} to remediate control {control}.',
      sentProduct:
        'You requested {targetOrg} to remediate control {control} in relation to {productName}.',
      received_review: 'Awaiting review from {targetOrg} on remediation of control {control}.',
      received_reviewProduct:
        'Awaiting review from {targetOrg} on remediation of control {control} in relation to {productName}.',
      sent_review: '{targetOrg} completed remediation of control {control}.',
      sent_reviewProduct:
        '{targetOrg} completed remediation of control {control} in relation to {productName}.',
      received_complete: '{targetOrg} accepted your remediation of control {control}.',
      received_completeProduct:
        '{targetOrg} accepted your remediation of control {control} in relation to {productName}.',
      sent_complete: '{targetOrg} completed remediation of control {control}.',
      sent_completeProduct:
        '{targetOrg} completed remediation of control {control} in relation to {productName}.',
      review: 'Review',
      view: 'View',
      deadline: 'Deadline:',
      expires: 'Deadline passes {time}',
      expired: 'Deadline passed {time}',
      searchPlaceholder: 'Search by supplier or control',
      columnSupplierName: 'Supplier name',
      columnClientName: 'Client name',
      columnControl: 'Control',
      columnRequestedDate: 'Requested date',
      columnStatus: 'Status',
      columnDeadline: 'Deadline',
      noDeadline: 'No deadline',
      productReference: 're: {productName}',
      filters: {
        received: 'Received',
        sent: 'Sent',
        awaiting_review: 'Awaiting review',
        awaiting_response: 'Awaiting remediation',
        completed: 'Completed',
      },
    },
    reviews: {
      columnSupplierName: 'Supplier name',
      columnProgress: 'Progress',
      reviewControls: 'Review controls',
      empty: 'No controls assigned to you.',
    },
    tabs: {
      connectionRequests: 'Connection requests',
      remediationRequests: 'Remediation requests',
      mergeRequests: 'Merge requests',
      reviews: 'Assigned controls',
      reviewSharing: 'Review access requests',
    },
    reviewSharing: {
      columnViewer: 'Community member',
      columnSupplier: 'Requesting access to',
      columnCommunity: 'Community',
      columnRequestedDate: 'Date received',
      reviewRequest: 'Review request',
      empty: 'No access requests to review.',
      grantModal: {
        title: 'Review access request',
        description: '{viewer} has requested access to your review of {supplier} in {community}',
        deny: 'Reject request',
        denyConfirmTitle: 'Reject this request?',
        denyConfirmDescription:
          '{viewer} will not be given access to any of your review details for {supplier}.',
        grant: 'Accept request',
        grantSuccess: 'Access request accepted.',
        grantError: 'Failed to accept access request.',
        partialGrantError:
          'Shared what you picked, but the rest of the request is still open. Try again.',
        denySuccess: 'Access request rejected.',
        denyError: 'Failed to reject access request.',
        notGrantableTitle: "You can't accept this request",
        notGrantableBody:
          'Your sharing settings changed, or this community connection has lapsed. You can still reject the request.',
      },
    },
    merges: {
      duplicateProfile: 'Duplicate profile',
      created: 'Created',
      connectionRequestCount: 'Connection requests',
      status: 'Status',
      statuses: {
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        all: 'All statuses',
      },
      actionsMenu: {
        viewSupplier: 'Review duplicate',
        accept: 'Accept',
        reject: 'Reject',
        moreActions: 'More actions',
      },
    },
    csvExport: {
      export: 'Export',
      success: 'Export complete.',
      error: 'Failed to generate CSV. Please try again.',
      connectionRequests: {
        filename: 'RiskLedger-ConnectionRequests',
        supplierName: 'Supplier name',
        clientName: 'Client name',
        sender: 'Sender',
        sentDate: 'Sent date',
        status: 'Status',
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        message: 'Message',
        contactName: 'Point of contact name',
        contactEmail: 'Point of contact email',
        acceptedDate: 'Accepted date',
        rejectedDate: 'Rejected date',
        statusUpdatedAt: 'Status updated date',
        dateFormat: 'yyyy/MM/dd',
      },
    },
  },
};
